// extracted by mini-css-extract-plugin
module.exports = {"outer":"Badges-module--outer--2s6vO","anchor":"Badges-module--anchor--aavoI","img":"Badges-module--img--2XeGs"};